import { AppData } from "@/src/constants/app-data";
import { ArrowRight, Star } from "lucide-react";

export function BrandStory() {
    return (
        <section className="bg-stone-100 py-24">
            <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                <div className="relative">
                    <img
                        src="https://images.unsplash.com/photo-1544468266-6a8948003cd7?auto=format&fit=crop&q=80&w=1000"
                        alt="Process"
                        className="w-full aspect-square object-cover rounded-sm luxury-shadow"
                        referrerPolicy="no-referrer"
                    />
                    <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-white p-6 hidden md:flex flex-col justify-center items-center text-center rounded-sm luxury-shadow">
                        <Star className="text-stone-300 mb-2" size={24} />
                        <p className="text-xs uppercase tracking-widest font-medium">
                            100% Vegan Soy Wax
                        </p>
                    </div>
                </div>
                <div className="space-y-8">
                    <h2 className="font-serif text-4xl md:text-6xl font-light leading-tight">
                        Crafted with <span className="italic">intention</span>,
                        poured with care.
                    </h2>
                    <p className="text-stone-600 leading-relaxed font-light text-lg">
                        ${AppData["AppName"]} was born from a desire to bring
                        the serenity of nature into the modern home. We believe
                        that scent is the most powerful bridge to memory and
                        emotion. Our candles are designed to be more than just
                        light—they are anchors for your daily rituals.
                    </p>
                    <div className="grid grid-cols-2 gap-8 pt-4">
                        <div>
                            <h4 className="font-serif text-xl mb-2">
                                Sustainability
                            </h4>
                            <p className="text-sm text-stone-500 font-light">
                                Recyclable glass vessels and carbon-neutral
                                shipping.
                            </p>
                        </div>
                        <div>
                            <h4 className="font-serif text-xl mb-2">Quality</h4>
                            <p className="text-sm text-stone-500 font-light">
                                Phthalate-free fragrance oils and lead-free
                                cotton wicks.
                            </p>
                        </div>
                    </div>
                    <button className="flex items-center gap-3 group text-sm uppercase tracking-widest font-medium pt-4">
                        Our Full Story{" "}
                        <ArrowRight
                            size={18}
                            className="group-hover:translate-x-2 transition-transform"
                        />
                    </button>
                </div>
            </div>
        </section>
    );
}
